import type { InstanceStatus, JobStatus, StepStatus } from '../api';

const LABELS: Record<InstanceStatus | JobStatus | StepStatus, string> = {
  ready: 'Prête',
  provisioning: 'Déploiement…',
  failed: 'Échec',
  removed: 'Retirée',
  queued: 'En attente',
  running: 'En cours',
  succeeded: 'Réussie',
  pending: 'À faire',
  done: 'Terminée',
  skipped: 'Ignorée',
};

const TONES: Record<InstanceStatus | JobStatus | StepStatus, string> = {
  ready: 'green',
  provisioning: 'orange',
  failed: 'red',
  removed: 'gray',
  queued: 'gray',
  running: 'orange',
  succeeded: 'green',
  pending: 'gray',
  done: 'green',
  skipped: 'gray',
};

export function StatusBadge({ status }: { status: InstanceStatus | JobStatus | StepStatus }) {
  const busy = status === 'provisioning' || status === 'running';
  return (
    <span className={`badge badge-${TONES[status]}${busy ? ' badge-busy' : ''}`} data-status={status}>
      <span className="badge-dot" aria-hidden="true" />
      {LABELS[status]}
    </span>
  );
}
